import { Alert, Button } from '@mui/material'
import { useCallback, useEffect, useRef, useState } from 'react'

import { CenteredLoading } from '../../CenteredLoading/CenteredLoading'
import SelectPrinter from './SelectPrinter'

export interface Printer {
  name: string
  type: string
  model: string
  isLocal: boolean
  isConnected: boolean
  isTwinTurbo: boolean
}

const GetPrinters = () => {
  const initStarted = useRef<boolean>(false)

  const [printers, setPrinters] = useState<Printer[] | undefined>()
  const [loading, setLoading] = useState(false)

  const getPrinters = useCallback(async () => {
    setLoading(true)
    try {
      const printers = window.dymo.label.framework.getPrinters()
      if (printers.length === 0) {
        setPrinters([])
        return
      }
      const foundPrinters: Printer[] = []
      printers.forEach(function (printer: any) {
        const printerType = printer.printerType
        const printerName = printer.name
        const printerModelName = printer.modelName
        const printerIsLocal = printer.isLocal
        const printerIsConnected = printer.isConnected
        const printerIsTwinTurbo = printer.isTwinTurbo
        foundPrinters.push({
          name: printerName,
          type: printerType,
          model: printerModelName,
          isLocal: printerIsLocal,
          isConnected: printerIsConnected,
          isTwinTurbo: printerIsTwinTurbo
        })
      })
      setPrinters(foundPrinters)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!initStarted.current) {
      initStarted.current = true
      getPrinters()
    }
  }, [getPrinters])

  return (
    <>
      {!printers && <CenteredLoading />}
      {printers && printers.length === 0 && (
        <Button variant="outlined" disabled={loading} onClick={getPrinters}>
          Refresh Available Printers
        </Button>
      )}
      {printers?.length === 0 && (
        <Alert severity="error">No printers found</Alert>
      )}
      {printers && printers.length > 0 && <SelectPrinter printers={printers} />}
    </>
  )
}

export default GetPrinters
